<template>
  <div class="box-login" ref="box" v-show="showBox">
    <div class="login-box">
      <h1 class="title" :style="{'background-color':color}">
        <div>验证信息</div>
      </h1>
      <div class="login-content">
        <p style="margin-bottom: 32px;">
          <label>手机号/邮箱</label>
          <input @blur="yanPhone" v-model="phoneEmail" type="text" placeholder="手机号/邮箱">
          <span v-if="showPhoneEmailErr" class="tips">请输入合法的手机号/邮箱</span>
        </p>
        <p>
          <label>验证码</label>
          <input style="width: 162px;" @blur="yanCode" @keydown.enter="login" v-model="code" type="text"
                 placeholder="验证码">
          <span class="get-code" :style="{'border-color':color,'color':color}" @click="getCode">{{codeText}}</span>
          <span v-if="codeErr" class="tips">请输入验证码</span>
          <span v-if="codeErr2" class="tips">请输入合法的手机号/邮箱</span>
        </p>
        <p style="margin-left: 45px;margin-top: 43px;color: #000000;font-size: 14px;">手机收不到验证码？ <span
          class="yuyin" style="color: red;" @click="getyuCode">试试语音验证码</span></p>
        <div style="text-align: center;margin-top: 50px;">
          <input :style="{'background-color':color}" @click="login" type="button" value="确定">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        flag: true,
        getCodeStatus: 0,//获取验证码
        phoneEmail: '',
        code: '',
        timer: '',
        showPhoneEmailErr: false, //显示手机号码或者邮箱错误
        codeErr: false, //验证码为空显示提示
        codeErr2: false //验证码错误
      }
    },
    props: {
      showBox: {
        type: Boolean,
        default: () => {
          return false;
        }
      },
      color: {
        type: String,
        default: () => {
          return '#CD0B09'
        }
      }
    },
    watch: {
//        监听显示box状态，如果是新显示的，就重置所有的校验
      showBox(newValue){
        if (newValue) {
          this.phoneEmail = '';
          this.code = '';
          this.timer = null;
          this.showPhoneEmailErr = false;
          this.codeErr = false;
          this.codeErr2 = false;
        }
      }
    },
    methods: {
      getyuCode(){
        let phoneReg = /^1[3|4|5|8]\d{9}$/;
        let params;
        let url = '/medapp/api/register/identify';
        if (!phoneReg.test(this.phoneEmail)) {
          this.$Message.info('请输入合法的手机号码');
          return;
        } else {
          let params = {
            phone: this.phoneEmail,
            type: 'VLOGIN'
          }
          axios.post('/medapp//api/register/identify', params)
            .then((data) => {
              console.log(data);
              this.$Message.info('验证码已经发送，请查收');
            })
        }
      },
      yanPhone(){
        let phoneReg = /^1[3|4|5|8]\d{9}$/;
        let emailReg = /^[\w.\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/;
        if (phoneReg.test(this.phoneEmail.trim()) || emailReg.test(this.phoneEmail.trim())) {
          this.showPhoneEmailErr = false;
          return true;
        }
        this.showPhoneEmailErr = true;
        return true;
      },
      //验证码blur的时候进行校验
      yanCode(){
        if (this.code.trim().length === 0) {
          this.codeErr = true;
          return false;
        }
        this.codeErr = false;
        return true;
      },
      getCode(){

        if (!this.regphoneEmail()) return;
        if (!this.flag) {
          this.$Message.info('请稍后获取');
          return;
        }
        let emailReg = /^[\w.\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/;
        let phoneReg = /^1[3|4|5|8]\d{9}$/;
        let params;
        let url = '/medapp/api/register/identify';

        let params1 = {
          phone: this.phoneEmail,
          type: 'LOGIN'
        };
        let params2 = {
          email: this.phoneEmail,
          type: 'LOGIN'
        };
        if (emailReg.test(this.phoneEmail)) {
//              检测到时邮箱
          params = params2;
        } else {
//            检测到手机号
          params = params1;
        }
        axios.post(url, params)
          .then(({data}) => {
            if(data.code == 0){
              this.flag = false;
              this.getCodeStatus = 60;
              this.timer = setInterval(() => {
                --this.getCodeStatus;
                if (this.getCodeStatus <= 0) {
                  clearInterval(this.timer);
                  this.flag = true;
                }
              }, 1000);
              console.log(data);
            }else{
              this.$Message.info('请稍后获取');
            }
          })
      },
      regphoneEmail(){
        let emailReg = /^[\w.\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/;
        let phoneReg = /^1[3|4|5|8]\d{9}$/;
        if (emailReg.test(this.phoneEmail) || phoneReg.test(this.phoneEmail)) {
          this.showPhoneEmailErr = false;
          return true;
        } else {
          this.showPhoneEmailErr = true;
          return false;
        }
      },

      login(){
//        "phone":"13000000000",        //app用户登录填写
//      “email”:raozhilei@163.com,  //后台管理等邮箱用户登录填写
//          "pwd":"900000",           //后台管理等用户登录填写
//      “identify”:”657841”,  //密码和验证码2选一，pwd为null 校验验证码
        if (!this.regphoneEmail()) return;
        if (!this.yanCode()) return;
        if (this.code.trim().length === 0) {
          this.codeErr = true;
          return;
        }
        let params;
        let emailReg = /^[\w.\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/;
        let phoneReg = /^1[3|4|5|8]\d{9}$/;
        let params1 = {
          phone: this.phoneEmail.trim(),
          identify: this.code.trim()
        };
        let params2 = {
          email: this.phoneEmail.trim(),
          identify: this.code.trim()
        };
        if (emailReg.test(this.phoneEmail.trim())) {
//              检测到时邮箱
          params = params2;
        } else {
//            检测到手机号
          params = params1;
        }
        axios.post('/medapp/api/register/identify/add', params)
          .then((data) => {
            console.log(data);
            if (data.data.code * 1 !== 0) {
              this.$Message.info('验证码错误');
              return;
            }
            localStorage.setItem('token', data.data.token.tToken);
            localStorage.setItem('uid', data.data.user.uId);
            localStorage.setItem('user', JSON.stringify(data.data.user));
            this.$emit('close');
            this.$Message.info('登录成功');
          })
      }
    },
    computed: {
      codeText(){
        return this.getCodeStatus === 0 ? '获取验证码' : `重新获取${this.getCodeStatus}s`
      }
    },
    mounted(){
      console.log(this.$refs)
      let box = this.$refs.box;
      console.log(box);
      box.addEventListener('click', (e) => {
        let classname = e.target.className.toLowerCase();
        if (classname === 'box-login') {
          this.$emit('close');
        }
      })
    }
  }
</script>
<style scoped>
  .box-login {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .7);
    z-index: 900;
  }

  .login-box {
    width: 450px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 18px;
    overflow: hidden;
  }

  label {
    font-size: 15px;
    margin-right: 18px;
    vertical-align: middle;
    color: #1d1d1d;
    display: inline-block;
    width: 90px;
    text-align: right;
  }

  input[type='text'] {
    height: 35px;
    padding-left: 15px;
    border: 1px solid #aaaaaa;
    width: 267px;
    border-radius: 20px;
  }

  input[type='button'] {
    width: 150px;
    line-height: 40px;
    font-size: 16px;
    background-color: #CD0B09;
    border: 0;
    border-radius: 5px;
    color: #ffffff;
    font-weight: 400;
    cursor: pointer;
  }

  p {
    vertical-align: middle;
    position: relative;
  }

  .title {
    color: #ffffff;
    text-align: center;
    background-color: #A10706;
    font-size: 18px;
    line-height: 40px;
    position: relative;
    height: 40px;
  }

  .title div {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    line-height: 40px;
    z-index: 2;
  }

  .title:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 50%;
    z-index: 0;
    /*background: linear-gradient(to top, rgba(255,255,255,.5),rgba(255,255,255,0));*/
    background: rgba(255, 255, 255, .15);
  }

  .login-content {
    background: #ffffff;
    padding-top: 60px;
    padding-bottom: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .yuyin:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .get-code {
    margin-left: 10px;
    border: 1px solid #A10706;
    padding: 8px 14px;
    border-radius: 20px;
    color: #A10706;
    cursor: pointer;
  }

  .tips {
    color: red;
    position: absolute;
    display: block;
    width: 100%;
    left: 113px;
    bottom: -20px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// login.vue?2ab27548